import { useState, useCallback } from 'react';
import { useAuthenticatedFetchWithWorkspace } from '../Keycloak/useAuthenticatedFetchWithWorkspace';

export interface DevisPayload {
  title: string;
  channel: string;
  sendDate: string;
  targetingSummary: string;
  nbRecipients: number | null;
}

// Télécharge le PDF "Devis" (encore un contenu placeholder côté backend, en attendant que la
// grille tarifaire et les CGV soient définies) via /api/communication/devis/pdf.
export const useDownloadDevis = () => {
  const { authFetch, isReady } = useAuthenticatedFetchWithWorkspace();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const downloadDevis = useCallback(
    async (payload: DevisPayload): Promise<boolean> => {
      if (!isReady) return false;
      setLoading(true);
      setError(null);
      try {
        const blob: Blob = await authFetch('/communication/devis/pdf', {
          method: 'POST',
          headers: { Accept: 'application/pdf' },
          body: JSON.stringify(payload),
        });

        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'devis.pdf';
        document.body.appendChild(link);
        link.click();
        link.remove();
        URL.revokeObjectURL(url);
        return true;
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Erreur lors du téléchargement du devis');
        return false;
      } finally {
        setLoading(false);
      }
    },
    [authFetch, isReady]
  );

  return { downloadDevis, loading, error };
};
